export default __webpack_public_path__ + "static/media/resume.263b5d2e.pdf";